export default {
  register: {
    title: 'Create New Account',
    subtitle: 'Welcome to our platform',
    emailRegister: 'Email Register',
    phoneRegister: 'Phone Register',
    email: 'Email Address',
    phone: 'Phone Number',
    countryCode: 'Country Code',
    phoneWithCode: 'Phone Number (with code)',
    sendCode: 'Send Code',
    resendCode: 'Resend',
    countdown: 's',
    verificationCode: 'Verification Code',
    emailVerificationCode: 'Email Verification Code',
    phoneVerificationCode: 'Phone Verification Code',
    verificationCodePlaceholder: 'Enter 6-digit code',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    captcha: 'Captcha',
    captchaPlaceholder: 'Enter captcha',
    agreeTerms: 'I agree to the',
    termsOfService: 'Terms of Service',
    and: 'and',
    privacyPolicy: 'Privacy Policy',
    registerButton: 'Register',
    registering: 'Registering...',
    usernameRequired: 'Username is required',
    usernameMinLength: 'Username must be at least 3 characters',
    emailRequired: 'Email is required',
    emailInvalid: 'Please enter a valid email address',
    phoneRequired: 'Phone number is required',
    phoneInvalid: 'Please enter a valid phone number',
    countryCodeRequired: 'Please select country code',
    verificationCodeRequired: 'Please enter verification code',
    verificationCodeInvalid: 'Verification code is incorrect',
    verificationCodeSent: 'Verification code sent',
    verificationCodeSendFailed: 'Failed to send verification code',
    sending: 'Sending...',
    passwordRequired: 'Password is required',
    passwordMinLength: 'Password must be at least 6 characters',
    passwordMaxLength: 'Password must be no more than 12 characters',
    passwordLowercaseRequired: 'Password must contain at least one lowercase letter',
    passwordUppercaseRequired: 'Password must contain at least one uppercase letter',
    confirmPasswordRequired: 'Please confirm password',
    passwordMismatch: 'Passwords do not match',
    inviteCode: 'Invite Code',
    inviteCodePlaceholder: 'Please enter invite code',
    inviteCodeRequired: 'Invite code is required',
    captchaRequired: 'Please enter captcha',
    captchaInvalid: 'Captcha is incorrect',
    captchaError: 'Failed to load captcha',
    refreshCaptcha: 'Click to refresh captcha',
    sliderCaptchaInProgress: 'Slider verification in progress, please wait...',
    sliderCaptchaSuccess: 'Slider verification successful!',
    agreeTermsRequired: 'Please agree to Terms of Service and Privacy Policy',
    becomeAgent: 'Become an Agent',
    becomeAgentClicked: 'Agent application feature is under development...',
    becomeAgentDescription: 'Choose to become an agent for more privileges and benefits',
    agentBenefits: 'Agent Benefits',
    agentBenefitsList: '• Exclusive agent privileges\n• Higher profit sharing\n• Priority access to new features\n• Dedicated customer support',
    registerSuccess: 'Registration successful!',
    registerFailed: 'Registration failed, please try again',
    encryptionFailed: 'Password encryption failed, please try again',
    newUserReward: 'New users who register and recharge 200 diamonds or more will receive 100 diamonds'
  },
  download: {
    title: 'Scan to Download',
    officialWebsite: 'Official Website Download',
    scanToDownload: 'Congratulations on successful registration! Scan the QR code to start your experience'
  },
  promotion: {
    title: 'Invite New Friends to Join, Share Diamond Rewards',
    rule: 'Invite friends to register and make their first recharge of 200 stones or more. Both the inviter and friend will receive 100 and 200 diamond rewards respectively',
    loading: 'Loading...',
    inviteButton: 'Invite Now',
    myRecords: 'My Records',
    totalInvited: 'Total invited: {count}',
    totalReward: 'Total reward: {count}',
    inviteRecords: 'Invite Records',
    rewardRecords: 'Reward Records',
    registeredAndRecharged: 'Registered and First Recharge',
    rewardForRegistration: 'Registration and First Recharge Reward',
    userMasked: 'User***{mask}',
    statusRegistered: 'Registered',
    statusRecharged: 'Recharged',
    statusPlayed: 'Played 10 Games',
    noInviteRecords: 'No invite records',
    noRewardRecords: 'No reward records',
    inviteTitle: 'Invite Friends',
    inviteSubtitle: 'Share invite link or invite code with friends',
    inviteCode: 'Invite Code',
    inviteLink: 'Invite Link',
    scanQRCode: 'Scan QR Code',
    shareLink: 'Share Link',
    linkCopied: 'Link copied',
    codeCopied: 'Invite code copied',
    copySuccess: 'Copy successful',
    copyFailed: 'Copy failed, please copy manually',
    copyManually: 'Please manually copy the following content:',
    clickOKToContinue: 'Click OK to continue',
    loadMore: 'Load More'
  },
  common: {
    logo: 'App Logo',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    back: 'Back',
    next: 'Next',
    previous: 'Previous'
  },
  notFound: {
    title: 'Page Not Found',
    subtitle: 'The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.',
    goBack: 'Go Back',
    goHome: 'Go Home'
  },
  countries: {
    searchPlaceholder: 'Search countries/regions',
    china: 'China',
    usa: 'United States',
    japan: 'Japan',
    korea: 'South Korea',
    uk: 'United Kingdom',
    germany: 'Germany',
    france: 'France',
    canada: 'Canada',
    australia: 'Australia',
    singapore: 'Singapore',
    hongKong: 'Hong Kong',
    taiwan: 'Taiwan',
    macau: 'Macau',
    malaysia: 'Malaysia',
    thailand: 'Thailand',
    vietnam: 'Vietnam',
    india: 'India',
    russia: 'Russia',
    brazil: 'Brazil',
    mexico: 'Mexico',
    italy: 'Italy',
    spain: 'Spain',
    netherlands: 'Netherlands',
    switzerland: 'Switzerland',
    sweden: 'Sweden',
    norway: 'Norway',
    denmark: 'Denmark',
    finland: 'Finland',
    poland: 'Poland',
    czech: 'Czech Republic',
    hungary: 'Hungary',
    austria: 'Austria',
    belgium: 'Belgium',
    portugal: 'Portugal',
    greece: 'Greece',
    turkey: 'Turkey',
    israel: 'Israel',
    uae: 'United Arab Emirates',
    saudiArabia: 'Saudi Arabia',
    egypt: 'Egypt',
    southAfrica: 'South Africa',
    nigeria: 'Nigeria',
    kenya: 'Kenya',
    morocco: 'Morocco',
    algeria: 'Algeria',
    tunisia: 'Tunisia',
    libya: 'Libya',
    sudan: 'Sudan',
    ethiopia: 'Ethiopia',
    uganda: 'Uganda',
    tanzania: 'Tanzania',
    ghana: 'Ghana',
    ivoryCoast: 'Ivory Coast',
    senegal: 'Senegal',
    mali: 'Mali',
    burkinaFaso: 'Burkina Faso',
    niger: 'Niger',
    chad: 'Chad',
    centralAfricanRepublic: 'Central African Republic',
    cameroon: 'Cameroon',
    gabon: 'Gabon',
    congo: 'Congo',
    democraticRepublicOfCongo: 'Democratic Republic of Congo',
    angola: 'Angola',
    guinea: 'Guinea',
    sierraLeone: 'Sierra Leone',
    liberia: 'Liberia',
    togo: 'Togo',
    benin: 'Benin',
    mauritania: 'Mauritania',
    gambia: 'Gambia',
    guineaBissau: 'Guinea-Bissau',
    capeVerde: 'Cape Verde',
    saoTomeAndPrincipe: 'São Tomé and Príncipe',
    equatorialGuinea: 'Equatorial Guinea',
    saintHelena: 'Saint Helena',
    reunion: 'Réunion',
    mayotte: 'Mayotte',
    comoros: 'Comoros',
    seychelles: 'Seychelles',
    mauritius: 'Mauritius',
    madagascar: 'Madagascar',
    malawi: 'Malawi',
    zambia: 'Zambia',
    zimbabwe: 'Zimbabwe',
    botswana: 'Botswana',
    namibia: 'Namibia',
    lesotho: 'Lesotho',
    eswatini: 'Eswatini',
    mozambique: 'Mozambique',
    // 添加更多国家的翻译
    indonesia: 'Indonesia',
    philippines: 'Philippines',
    cambodia: 'Cambodia',
    laos: 'Laos',
    myanmar: 'Myanmar',
    mongolia: 'Mongolia',
    kazakhstan: 'Kazakhstan',
    kyrgyzstan: 'Kyrgyzstan',
    tajikistan: 'Tajikistan',
    turkmenistan: 'Turkmenistan',
    uzbekistan: 'Uzbekistan',
    azerbaijan: 'Azerbaijan',
    georgia: 'Georgia',
    armenia: 'Armenia',
    moldova: 'Moldova',
    belarus: 'Belarus',
    ukraine: 'Ukraine',
    romania: 'Romania',
    bulgaria: 'Bulgaria',
    serbia: 'Serbia',
    croatia: 'Croatia',
    slovenia: 'Slovenia',
    slovakia: 'Slovakia',
    estonia: 'Estonia',
    latvia: 'Latvia',
    lithuania: 'Lithuania',
    iceland: 'Iceland',
    ireland: 'Ireland',
    luxembourg: 'Luxembourg',
    // malta: 'Malta',
    cyprus: 'Cyprus',
    qatar: 'Qatar',
    bahrain: 'Bahrain',
    kuwait: 'Kuwait',
    oman: 'Oman',
    yemen: 'Yemen',
    jordan: 'Jordan',
    lebanon: 'Lebanon',
    syria: 'Syria',
    iraq: 'Iraq',
    iran: 'Iran',
    afghanistan: 'Afghanistan',
    bhutan: 'Bhutan',
    maldives: 'Maldives',
    brunei: 'Brunei',
    eastTimor: 'East Timor',
    papuaNewGuinea: 'Papua New Guinea',
    fiji: 'Fiji',
    vanuatu: 'Vanuatu',
    newCaledonia: 'New Caledonia',
    solomonIslands: 'Solomon Islands',
    samoa: 'Samoa',
    tonga: 'Tonga',
    cookIslands: 'Cook Islands',
    niue: 'Niue',
    tuvalu: 'Tuvalu',
    kiribati: 'Kiribati',
    marshallIslands: 'Marshall Islands',
    micronesia: 'Micronesia',
    palau: 'Palau',
    nauru: 'Nauru',
    pitcairn: 'Pitcairn Islands',
    wallisAndFutuna: 'Wallis and Futuna',
    frenchPolynesia: 'French Polynesia',
    americanSamoa: 'American Samoa',
    guam: 'Guam',
    northernMarianaIslands: 'Northern Mariana Islands',
    palestine: 'Palestine',
    westernSahara: 'Western Sahara',
    southSudan: 'South Sudan',
    eritrea: 'Eritrea',
    djibouti: 'Djibouti',
    somalia: 'Somalia',
    rwanda: 'Rwanda',
    burundi: 'Burundi',
    republicOfCongo: 'Republic of Congo',
    // Add missing country translations
    sanMarino: 'San Marino',
    bangladesh: 'Bangladesh',
    bolivia: 'Bolivia',
    guatemala: 'Guatemala',
    chile: 'Chile',
    elSalvador: 'El Salvador',
    nicaragua: 'Nicaragua',
    peru: 'Peru',
    honduras: 'Honduras',
    paraguay: 'Paraguay',
    venezuela: 'Venezuela',
    colombia: 'Colombia',
    argentina: 'Argentina',
    ecuador: 'Ecuador',
    newZealand: 'New Zealand'
  }
}
